<template>
  <div class="colored-status" :style="`background-color: ${color}; color: ${textColor || 'white'}`">
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
.colored-status {
  padding: 2px 8px;
  display: inline-block;
  color: white;
  background-color: #4f4f4f;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  border-radius: 4px;
  max-height: max-content;
}
</style>

<script>
export default {
  props: ['color', 'textColor']
}
</script>